import { formatActivityWhenDeCh } from "./activityWhenDisplay";

/** Display labels for lowercase tag keys stored in user_cards.tags */
export const TAG_LABELS = {
  indoor: "Drinnen",
  outdoor: "Draussen",
  rain_ok: "Bei Regen",
  stroller_friendly: "Kinderwagen",
  quick: "Kurz",
  booking_needed: "Reservieren",
  food_nearby: "Essen in der Nähe",
  wc: "WC",
};

export function normalizeTags(tags) {
  if (!Array.isArray(tags)) return [];
  return tags
    .map((t) => (typeof t === "string" ? t.trim().toLowerCase() : ""))
    .filter(Boolean);
}

export function formatTagLabel(key) {
  return TAG_LABELS[key] || key.replace(/_/g, " ");
}

function isUnknownAgeHint(value) {
  if (!value || typeof value !== "string") return true;
  const normalized = value.toLowerCase().trim();
  if (!normalized) return true;
  const unknownPatterns = [
    "unknown",
    "unknown age",
    "age unknown",
    "unbekannt",
    "alter unbekannt",
    "k.a.",
    "n/a",
    "na",
    "keine angabe",
  ];
  return unknownPatterns.includes(normalized);
}

/** Up to `max` chip labels for tiles */
export function chipLabelsFromItem(item, max = 3) {
  const tags = normalizeTags(item?.tags);
  const labels = tags.map(formatTagLabel);
  if (!isUnknownAgeHint(item?.age_hint)) labels.push(item.age_hint.trim());
  if (labels.length >= max) return labels.slice(0, max);
  if (item?.duration_hint?.trim()) labels.push(item.duration_hint.trim());
  return labels.slice(0, max);
}

/** Single secondary line for compact tiles (activity-first: summary, then when/hints, then where) */
export function tileSecondaryLine(item, isStory) {
  if (isStory) {
    return item?.storyline ? String(item.storyline).trim() : "";
  }
  const lines = summaryBulletLines(item?.summary);
  const firstSummary = lines[0] || "";
  const whenStr = formatActivityWhenDeCh(item?.starts_at, item?.ends_at);
  const dur = item?.duration_hint?.trim() || "";
  const age = item?.age_hint?.trim() || "";
  const loc = item?.location?.trim() || "";

  const parts = [];
  if (firstSummary) {
    parts.push(firstSummary);
    if (loc) parts.push(loc);
    return parts.join(" · ");
  }

  if (whenStr) parts.push(whenStr);
  if (dur) parts.push(dur);
  if (age) parts.push(age);
  if (loc) parts.push(loc);
  return parts.join(" · ");
}

/**
 * Summary bullets for parent brief; trims and drops empty lines.
 * @param {string} summary
 * @returns {string[]}
 */
export function summaryBulletLines(summary) {
  if (!summary || typeof summary !== "string") return [];
  return summary
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);
}

/** Lowercase string for search (title, meta, brief fields, tags). */
export function searchableItemText(item, type) {
  const tags = normalizeTags(item?.tags).join(" ");
  const extra = [
    item?.summary,
    item?.age_hint,
    item?.duration_hint,
    item?.price_hint,
    item?.booking_hint,
    tags,
  ]
    .filter(Boolean)
    .join(" ");
  if (type === "story") {
    return `${item?.title || ""} ${item?.storyline || ""} ${extra}`.toLowerCase();
  }
  return `${item?.title || ""} ${item?.starts_at || ""} ${item?.ends_at || ""} ${item?.series_id || ""} ${item?.location || ""} ${extra}`.toLowerCase();
}
